// extracted by mini-css-extract-plugin
export var dropdownContainer = "_nr-0";
export var leftAlign = "_nr-4";
export var listItem = "_nr-2";
export var listItemWrapper = "_nr-1";
export var operationText = "_nr-3";